import { JobView } from 'pages/common/job/JobView';
import React from 'react';

export const ViewJob: React.FC<any> = () => {
  return <JobView />;
};
